<template>
  <div />
</template>

<script>
import store from "@/store";
import {
  ARCHES_OPEN_STUDENT_TASK_KEY,
  consumeOpenStudentTask,
} from "@/utils/consumeOpenStudentTask";
import { hydratePortalLessonAndEnter } from "@/utils/hydratePortalLesson";
import { resumeProgressFromStoredPayload } from "@/utils/portalVuexResume";

const RESUME_SESSION_KEY = "arches_resume_from_nuxt";
const OPEN_LESSON_KEY = "arches_nuxt_open_lesson";

export default {
  name: "PortalVuexHandoff",
  async mounted() {
    const router = this.$router;

    const resumeRaw = sessionStorage.getItem(RESUME_SESSION_KEY);
    if (resumeRaw) {
      sessionStorage.removeItem(RESUME_SESSION_KEY);
      try {
        const { progress } = JSON.parse(resumeRaw);
        const student = store.getters.student;
        if (progress && student?.email) {
          await resumeProgressFromStoredPayload(router, progress, student.email);
          return;
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }

    const taskRaw = sessionStorage.getItem(ARCHES_OPEN_STUDENT_TASK_KEY);
    if (taskRaw) {
      sessionStorage.removeItem(ARCHES_OPEN_STUDENT_TASK_KEY);
      try {
        const payload = JSON.parse(taskRaw);
        await consumeOpenStudentTask(router, payload);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
      return;
    }

    const lessonRaw = sessionStorage.getItem(OPEN_LESSON_KEY);
    if (lessonRaw) {
      sessionStorage.removeItem(OPEN_LESSON_KEY);
      try {
        const { lessonUuid, studentEmail } = JSON.parse(lessonRaw);
        if (lessonUuid && studentEmail) {
          await hydratePortalLessonAndEnter(router, lessonUuid, studentEmail);
          return;
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }

    window.location.assign("/app/modules");
  },
};
</script>
